import {
  SET_CQ9_GAME_NAMES,
  SET_CQ9_GAME_IMAGES,
  SET_CQ9_GAME_POLA,
  SET_GAME_ISLOADING,
  SET_GAME_ISERROR
} from '../actionTypes';

const initialState = {
  cq9Names: [],
  cq9Images: [],
  cq9Polas: [],
  nameAndImagesIsLoading: true,
  isError: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CQ9_GAME_NAMES:
      return { ...state, cq9Names: action.payload }
    case SET_CQ9_GAME_IMAGES:
      return { ...state, cq9Images: action.payload };
    case SET_CQ9_GAME_POLA:
      return { ...state, cq9Polas: action.payload };
    case SET_GAME_ISLOADING:
      return { ...state, nameAndImagesIsLoading: action.payload };
    case SET_GAME_ISERROR:
      return { ...state, isError: action.payload };
    default:
      return state;
  };
};

export default reducer;